import { graphql } from "@/graphql/generated/gql";

export const getFocusAreaInstancebyOwnerQueryDocument = graphql(/* GraphQL */ `
  query GetFocusAreaInstanceByOwner($input: GetFocusAreaInstanceByOwnerInput!) {
    focusAreaInstanceByOwner(getFocusAreaInstanceByOwnerInput: $input) {
      ...FocusAreaInstanceFields
      focusArea {
        ...FocusAreaFields
      }
    }
  }
`);

export const createFocusAreaInstanceMutationDocument = graphql(/* GraphQL */ `
  mutation createFocusAreaInstance($input: CreateFocusAreaInstanceInput!) {
    createFocusAreaInstance(createFocusAreaInstanceInput: $input) {
      ...FocusAreaInstanceFields
      focusArea {
        ...FocusAreaFields
      }
    }
  }
`);

export const updateFocusAreaInstanceMutationDocument = graphql(/* GraphQL */ `
  mutation updateFocusAreaInstance($input: UpdateFocusAreaInstanceInput!) {
    updateFocusAreaInstance(updateFocusAreaInstanceInput: $input) {
      ...FocusAreaInstanceFields
      focusArea {
        ...FocusAreaFields
      }
    }
  }
`);

export const deleteFocusAreaInstanceMutationDocument = graphql(/* GraphQL */ `
  mutation deleteFocusAreaInstance($input: DeleteFocusAreaInstanceInput!) {
    deleteFocusAreaInstance(deleteFocusAreaInstanceInput: $input) {
      ...FocusAreaInstanceFields
      focusArea {
        ...FocusAreaFields
      }
    }
  }
`);
